import React from 'react'
import cx from 'classnames'
import { useAppSelector } from 'reduxTyped'
import { LinkBtn, l } from '@manychat/manyui'

import { InstagramPreviewButton } from 'apps/flowPlayer/components/InstagramPreviewButton/InstagramPreviewButton'
import { TiktokPreviewButton } from 'apps/flowPlayer/components/TiktokPreviewButton/TiktokPreviewButton'
import { getRootChannelsInfo } from 'common/builder/selectors/builder/builderStateSelectorsTyped'

import cm from './PreviewButton.module.css'

interface PreviewButtonProps {
  messengerPreviewUrl: string
  builderId: string
}

export const PreviewButton = ({ builderId, messengerPreviewUrl }: PreviewButtonProps) => {
  const { isMixed, hasInstagram, hasTiktok } = useAppSelector((state) =>
    getRootChannelsInfo(state, builderId),
  )

  const isInstagramOnlyFlow = !isMixed && hasInstagram
  const isTiktokOnlyFlow = !isMixed && hasTiktok

  return (
    <div className={cm.buttons}>
      {hasInstagram && <InstagramPreviewButton />}
      {hasTiktok && <TiktokPreviewButton />}
      {!isInstagramOnlyFlow && !isTiktokOnlyFlow && (
        <LinkBtn
          variant="default"
          size="large"
          href={messengerPreviewUrl}
          target="_blank"
          leftIcon={'MessengerChannel'}
          className={cx(hasInstagram && 'm-l')}
        >
          <span>{l.translate('Preview')}</span>
        </LinkBtn>
      )}
    </div>
  )
}
